(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.shipping-calculator').forEach(function (calculator) {
      const input = calculator.querySelector('.shipping-calculator__input');
      const button = calculator.querySelector('.shipping-calculator__button');
      const labelEl = calculator.querySelector('.shipping-calculator__button-label');
      const loadingEl = calculator.querySelector('.shipping-calculator__button-loading');
      const results = calculator.querySelector('.shipping-calculator__results');

      input.addEventListener('input', function () {
        let value = input.value.replace(/\D/g, '').slice(0, 8);
        if (value.length > 5) value = value.slice(0, 5) + '-' + value.slice(5);
        input.value = value;
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') button.click();
      });

      button.addEventListener('click', async function () {
        const cep = input.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          showError('Digite um CEP válido com 8 dígitos.');
          return;
        }

        const variantId = getVariantId();
        if (!variantId) {
          showError('Selecione uma variante do produto antes de calcular.');
          return;
        }

        setLoading(true);

        try {
          const rates = await fetchRates(cep, variantId);

          if (!rates || rates.length === 0) {
            showError('Nenhuma opção de frete disponível para este CEP.');
            return;
          }

          renderResults(rates);
        } catch (error) {
          showError(error.message || 'Não foi possível calcular o frete. Tente novamente.');
        } finally {
          setLoading(false);
        }
      });

      async function fetchRates(cep, variantId) {
        const headers = { 'Content-Type': 'application/json' };

        // Busca o estado via ViaCEP
        const viaCepRes = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
        const viaCepData = await viaCepRes.json();

        if (viaCepData.erro) {
          throw new Error('CEP não encontrado. Verifique e tente novamente.');
        }

        const province = viaCepData.uf;

        // Salva quantidade atual no carrinho
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const existing = cart.items.find(function (i) { return i.variant_id == variantId; });
        const originalQty = existing ? existing.quantity : 0;

        // Adiciona 1 unidade temporariamente
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!addRes.ok) {
          const err = await addRes.json().catch(function () { return {}; });
          throw new Error(err.description || 'Produto indisponível para adicionar ao carrinho.');
        }

        let ratesData = null;
        let ratesOk = false;

        try {
          const ratesRes = await fetch(
            '/cart/shipping_rates.json?shipping_address[zip]=' + cep +
            '&shipping_address[country]=BR&shipping_address[province]=' + province
          );
          ratesOk = ratesRes.ok;
          ratesData = await ratesRes.json();
        } finally {
          // Sempre restaura, mesmo se a busca falhar
          const updatedCartRes = await fetch('/cart.js');
          const updatedCart = await updatedCartRes.json();
          const itemIndex = updatedCart.items.findIndex(function (i) { return i.variant_id == variantId; });
          if (itemIndex !== -1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({ line: itemIndex + 1, quantity: originalQty })
            });
          }
        }

        if (!ratesOk) {
          const errorMsg = (ratesData && (ratesData.error || ratesData.errors || JSON.stringify(ratesData))) || 'Sem resposta da API.';
          throw new Error(errorMsg);
        }

        return ratesData ? ratesData.shipping_rates : [];
      }

      function getVariantId() {
        // Seletor específico do tema (product-form-component)
        const input = document.querySelector('product-form-component input[name="id"]')
          || document.querySelector('input[name="id"]');
        if (input && input.value) return input.value;

        // Fallback: parâmetro variant= na URL
        const params = new URLSearchParams(window.location.search);
        if (params.get('variant')) return params.get('variant');

        return null;
      }

      function setLoading(loading) {
        button.disabled = loading;
        if (labelEl) labelEl.hidden = loading;
        if (loadingEl) loadingEl.hidden = !loading;
      }

      function showError(message) {
        results.hidden = false;
        results.innerHTML = `<p class="shipping-calculator__error">${message}</p>`;
      }

      function renderResults(rates) {
        results.hidden = false;
        results.innerHTML = rates.map(function (rate) {
          const isFree = parseFloat(rate.price) === 0;
          const priceClass = isFree
            ? 'shipping-calculator__result-price shipping-calculator__result-price--free'
            : 'shipping-calculator__result-price';
          const priceLabel = isFree ? 'Grátis' : formatMoney(parseFloat(rate.price) * 100);
          const rawDays = rate.delivery_days != null ? parseFloat(String(rate.delivery_days).replace(',', '.')) : null;
          const days = rawDays != null && !isNaN(rawDays) ? Math.floor(rawDays) : null;
          const deadline = days != null ? (days === 1 ? '1 dia útil' : days + ' dias úteis') : '';

          return `
            <div class="shipping-calculator__result-item">
              <span class="shipping-calculator__result-name">${rate.name}</span>
              ${deadline ? `<span class="shipping-calculator__result-deadline">${deadline}</span>` : ''}
              <span class="${priceClass}">${priceLabel}</span>
            </div>
          `;
        }).join('');
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeTabs(root = document) {
      root.querySelectorAll('.tabs').forEach(tabs => {
        if (tabs.dataset.tabsInitialized === 'true') return;

        const nav = tabs.querySelector(':scope > .tabs__nav');
        const panels = Array.from(
          tabs.querySelectorAll(':scope > .tabs__panels > .tab-panel')
        );

        if (!nav || panels.length === 0) return;

        tabs.dataset.tabsInitialized = 'true';
        nav.replaceChildren();

        const buttons = panels.map((panel, index) => {
          const button = document.createElement('button');

          button.type = 'button';
          button.id = `tab-button-${panel.id}`;
          button.className = 'tabs__btn';
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', panel.id);
          button.textContent = panel.dataset.tabHeading || `${index + 1}`;

          panel.setAttribute('aria-labelledby', button.id);
          panel.tabIndex = 0;

          nav.appendChild(button);

          return button;
        });

        function activateTab(activeIndex, moveFocus = false) {
          buttons.forEach((button, index) => {
            const active = index === activeIndex;

            button.classList.toggle('tabs__btn--active', active);
            button.setAttribute('aria-selected', String(active));
            button.tabIndex = active ? 0 : -1;
            panels[index].hidden = !active;
          });

          if (moveFocus) {
            buttons[activeIndex].focus();
          }
        }

        buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            activateTab(index);
          });

          button.addEventListener('keydown', event => {
            let nextIndex;

            switch (event.key) {
              case 'ArrowRight':
                nextIndex = (index + 1) % buttons.length;
                break;

              case 'ArrowLeft':
                nextIndex = (index - 1 + buttons.length) % buttons.length;
                break;

              case 'Home':
                nextIndex = 0;
                break;

              case 'End':
                nextIndex = buttons.length - 1;
                break;

              default:
                return;
            }

            event.preventDefault();
            activateTab(nextIndex, true);
          });
        });

        activateTab(0);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTabs());
    } else {
      initializeTabs();
    }

    document.addEventListener('shopify:section:load', event => {
      initializeTabs(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
